module.exports = __webpack_public_path__ + "img/aerial-shot-of-blue-water.b6501f0b.jpg";